import React, { FC } from 'react'
import SALink from 'components/SALink'
import SessionConnector, { ConnectorProps as SessionProps } from 'containers/Session'
import { getLogout } from 'apis/authentication'
import StudioIcon from 'svg/studio.svg'
import styles from './Account.module.scss'
import classNames from 'classnames'
import { useHeaderContext } from '../../HeaderContext'

export const ARTIST_TYPE = 2

type Props = SessionProps & {
  dropdownIsOpen: boolean
  dropdownIsHovered: boolean
}

const ArtistLinks: FC<Props> = ({ profileUrl, userId }) => {
  return (
    <>
      <SALink
        data-gtm-event='top-nav'
        className={classNames('defaultTypographyMedium', styles.accountDropDownContentAccountLink)}
        href='/studio'
        rel='nofollow'
      >
        Studio
      </SALink>

      <SALink
        data-gtm-event='top-nav'
        className={classNames('defaultTypographyMedium', styles.accountDropDownContentAccountLink)}
        href={profileUrl}
        rel='nofollow'
      >
        View Artist Profile
      </SALink>

      <span className={styles.accountDropDownContentLine} />

      <SALink
        data-gtm-event='top-nav'
        className={classNames('defaultTypographyMedium', styles.accountDropDownContentAccountLink)}
        href={`/u/${userId}`}
        rel='nofollow'
      >
        View Profile
      </SALink>

      <SALink
        data-gtm-event='top-nav'
        className={classNames('defaultTypographyMedium', styles.accountDropDownContentAccountLink)}
        href={`/account/favorite/${userId}`}
        rel='nofollow'
      >
        Favorites
      </SALink>

      <SALink
        data-gtm-event='top-nav'
        className={classNames('defaultTypographyMedium', styles.accountDropDownContentAccountLink)}
        href={`/account/collection/${userId}`}
        rel='nofollow'
      >
        Collections
      </SALink>

      <SALink
        data-gtm-event='top-nav'
        className={classNames('defaultTypographyMedium', styles.accountDropDownContentAccountLink)}
        href='/accounts/orders'
        rel='nofollow'
      >
        Orders
      </SALink>

      <SALink
        data-gtm-event='top-nav'
        className={classNames('defaultTypographyMedium', styles.accountDropDownContentAccountLink)}
        href='/accounts/offers'
        rel='nofollow'
      >
        Offers
      </SALink>

      <SALink
        data-gtm-event='top-nav'
        className={classNames('defaultTypographyMedium', styles.accountDropDownContentAccountLink)}
        href='/accounts/settings'
        rel='nofollow'
      >
        Account
      </SALink>

      <SALink
        data-gtm-event='top-nav'
        className={classNames('defaultTypographyMedium', styles.accountDropDownContentAccountLink)}
        href='/cart'
        rel='nofollow'
      >
        Cart
      </SALink>
    </>
  )
}

const CollectorLinks: FC<Props> = ({ profileUrl, userId }) => {
  return (
    <>
      <SALink
        data-gtm-event='top-nav'
        className={classNames('defaultTypographyMedium', styles.accountDropDownContentAccountLink)}
        href={`${profileUrl}`}
        rel='nofollow'
      >
        View Profile
      </SALink>

      <SALink
        data-gtm-event='top-nav'
        className={classNames('defaultTypographyMedium', styles.accountDropDownContentAccountLink)}
        href={`/account/favorite/${userId}`}
        rel='nofollow'
      >
        Favorites
      </SALink>

      <SALink
        data-gtm-event='top-nav'
        className={classNames('defaultTypographyMedium', styles.accountDropDownContentAccountLink)}
        href={`/account/collection/${userId}`}
        rel='nofollow'
      >
        Collections
      </SALink>

      <SALink
        data-gtm-event='top-nav'
        className={classNames('defaultTypographyMedium', styles.accountDropDownContentAccountLink)}
        href='/accounts/orders'
        rel='nofollow'
      >
        Orders
      </SALink>

      <SALink
        data-gtm-event='top-nav'
        className={classNames('defaultTypographyMedium', styles.accountDropDownContentAccountLink)}
        href='/accounts/offers'
        rel='nofollow'
      >
        Offers
      </SALink>

      <SALink
        data-gtm-event='top-nav'
        className={classNames('defaultTypographyMedium', styles.accountDropDownContentAccountLink)}
        href='/accounts/settings'
        rel='nofollow'
      >
        Account
      </SALink>

      <SALink
        data-gtm-event='top-nav'
        className={classNames('defaultTypographyMedium', styles.accountDropDownContentAccountLink)}
        href='/cart'
        rel='nofollow'
      >
        Cart
      </SALink>

      <span className={styles.accountDropDownContentLine} />

      <SALink
        data-gtm-event='top-nav'
        className={classNames(
          'defaultTypographyMedium',
          styles.accountDropDownContentAccountBecome,
          styles.accountDropDownContentAccountLink
        )}
        href='/whysell'
        rel='nofollow'
      >
        <StudioIcon />
        <span>Become an Artist</span>
      </SALink>
    </>
  )
}

const AccountLinksDropDown: FC<Props> = (props) => {
  const { userTypeId, dropdownIsOpen, dropdownIsHovered, authenticated } = props
  const { mobileHeaderConfig } = useHeaderContext()

  if (!authenticated) {
    return null
  }

  return (
    <div
      className={classNames(styles.accountDropDownContent, styles.accountDropDownContentAccount, {
        [styles.accountDropDownContentOpen]:
          dropdownIsOpen ||
          dropdownIsHovered ||
          (mobileHeaderConfig.isMobileMenuOpen && mobileHeaderConfig.mobileMenuContent === 'user'),
      })}
      data-type='account-dropdown-content'
    >
      {userTypeId === ARTIST_TYPE ? <ArtistLinks {...props} /> : <CollectorLinks {...props} />}

      <span className={styles.accountDropDownContentLine} />

      <SALink
        data-gtm-event='top-nav'
        className={classNames(
          'defaultTypographyMedium',
          styles.accountDropDownContentAccountLogout,
          styles.accountDropDownContentAccountLink
        )}
        href='/easel_api/auth/logout'
        onClick={async (event: React.SyntheticEvent<HTMLElement>) => {
          event.preventDefault()
          // API will DELETE session and we refresh the page
          await getLogout()
          location.reload()
        }}
        rel='nofollow'
      >
        Log Out
      </SALink>
    </div>
  )
}

export default SessionConnector(AccountLinksDropDown)
